import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Clips } from '@air/api';
import { type Upload, uploadByIdSelector } from '@air/redux-uploader';

import { getUploadBoardIdFromStore } from '~/components/Upload/utils/getUploadBoardIdFromStore';
import {
  type ClipGetOptionsWithBoards,
  defaultClipGetOptions,
  getClipWithoutWorkspaceIdKey,
} from '~/swr-hooks/useGetClipWithNoWorkspaceId';
import { useAirStore } from '~/utils/ReduxUtils';

export const useFetchClipForPrivateUpload = () => {
  const store = useAirStore();
  const client = useQueryClient();

  const fetchClipForPrivateUpload = useCallback(
    (uploadId: Upload['id']) => {
      const upload = uploadByIdSelector(store.getState(), uploadId);
      if (!upload) {
        return;
      }

      const boardId = getUploadBoardIdFromStore({ upload, store });

      const { clipId } = upload;

      const params: ClipGetOptionsWithBoards = {
        ...defaultClipGetOptions,
        boardId,
      };

      const cacheKey = getClipWithoutWorkspaceIdKey({ clipId, options: params });
      return client.ensureQueryData({
        queryKey: cacheKey,
        queryFn: () => Clips.getWithNoWorkspaceId({ id: clipId, options: params }),
      });
    },
    [client, store],
  );

  return { fetchClipForPrivateUpload };
};
